// 称号熟练度共用口径（2026-09-16 新增）
// 原先「熟练度上限」与「配方配色」两套口径在 createItem / cookingPanel / titleTypeList / professionPanel
// 各自复制了一份，阈值与默认值还互不一致（`|| 1` 与 `|| 175`）。统一到这里。

// 称号熟练度上限默认值（fantasy_title_ability.mastery_limit 配置值，本作生活/制造系均为 175）
export const MASTERY_LIMIT_DEFAULT = 175;

// 等级软上限系数：BaseAbility 与 TitleMasteryHelper 均为 mastery < 等级 × 5 才继续涨
export const MASTERY_PER_LEVEL = 5;

/**
 * 熟练度真实上限 = min(称号配置上限, 等级 × 5)
 * 后端是「双上限」：熟练度满或达到等级×5 后不再增长（但仍可正常使用能力）。
 * 界面原先只显示配置上限 175，玩家会误判「还能涨」——花匠要 175 实际需要 35 级。
 *
 * @param {number} masteryLimit 称号能力配置的熟练度上限
 * @param {number} level 玩家等级
 * @returns {number} 真实上限
 */
export function effectiveMasteryLimit(masteryLimit, level) {
  var limit = masteryLimit || MASTERY_LIMIT_DEFAULT;
  var lv = parseInt(level, 10);
  if (!lv || lv <= 0) {
    return limit;
  }
  return Math.min(limit, lv * MASTERY_PER_LEVEL);
}

/**
 * 熟练度进度百分比（按真实上限）
 */
export function masteryPercent(mastery, masteryLimit, level) {
  var limit = effectiveMasteryLimit(masteryLimit, level) || 1;
  var cur = mastery || 0;
  return Math.min(100, Math.round(cur / limit * 100)) + '%';
}

/**
 * 配方配色：按「玩家熟练度 − 配方门槛」分档，与 BaseAbility.getAddMastery 的熟练度增量分档一致
 * （差 ≥15 不再涨熟练度 → 灰），厨师面板与制造面板原来各写一份。
 *
 * @param {number} mastery 玩家该称号熟练度
 * @param {number} recipeMastery 配方最低熟练度
 * @returns {string} CSS 颜色
 */
export function masteryColor(mastery, recipeMastery) {
  var diff = (mastery || 0) - (recipeMastery || 0);
  if (diff >= 15) {
    return 'gray';
  }
  if (diff >= 10) {
    return 'green';
  }
  if (diff >= 5) {
    return '#eeee00';
  }
  if (diff >= 0) {
    return 'orange';
  }
  return 'red';
}

/**
 * 熟练度增量档位文案（配色图例用）
 */
export function masteryColorLegend() {
  return [
    {color: 'orange', text: '熟练度+1~2'},
    {color: '#eeee00', text: '熟练度+1'},
    {color: 'green', text: '熟练度+0~1'},
    {color: 'gray', text: '不再涨熟练度'}
  ];
}
